import { makeStyles } from '@fluentui/react-components';
import { tokens, useFluentTokens } from '../../../../../theme/fluent';

export const MorningDashBoardCardHeaderStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: tokens.spacingVerticalXXL,
  },
  description: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  leftContent: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    flexGrow: 1,
    minWidth: 0,
  },
  rightContent: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: tokens.spacingHorizontalS,
    flexGrow: 1,
  },
  flexStart: {
    marginTop: tokens.spacingVerticalXS,
    justifyContent: 'flex-start',
  },
  flexEnd: {
    justifyContent: 'flex-end',
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

export const useMorningDashBoardCardHeaderStyles = () => {
  const classes = MorningDashBoardCardHeaderStyles();
  const { modeTokens } = useFluentTokens();

  const addBtnStyle: React.CSSProperties = {};

  const addBtnStyleRadius: React.CSSProperties = {
    borderRadius: tokens.borderRadiusXLarge,
  };

  const descriptionColorStyle: React.CSSProperties = {
    color: modeTokens.widgetCardHeaderDescription,
  };

  const addBtnDisabledStyle: React.CSSProperties = {
    color: modeTokens.buttonDisabledColor,
  };

  return { classes, addBtnStyle, addBtnStyleRadius, addBtnDisabledStyle, descriptionColorStyle };
};
